<template>
    <a-modal v-model="modalVisible" title="详情" :footer="null">
        <div class="list_item_box">
            <div class="list_item_data">
                <div v-for="(item,index) in columns" :key="index">
                    <div class="list_item_data_item" v-if="currentModalData[item.dataIndex] != 'null'">
                        <div class="list_item_data_item_key">{{item.title}}</div>
                        <span>:</span>
                        <span class="list_item_data_item_value" >{{ currentModalData[item.dataIndex] }}</span>
                    </div>
                </div>
            </div>
        </div>
    </a-modal>
</template>

<script>
export default {
    data(){
        return {
            modalVisible:false,
            columns:[
                {
                    title:'发生时间',
                    dataIndex:'log_time'
                },
                {
                    title:'日志类型',
                    dataIndex:'log_type'
                },
                {
                    title:'登陆用户',
                    dataIndex:'user_sign'
                },
                {
                    title:'sessionID',
                    dataIndex:'session_id'
                },
                //-------事件参数------
                //pv
                {
                    title:'是否首次访问',
                    dataIndex:'pv_is_first'
                },
                {
                    title:'加载时间 ms',
                    dataIndex:'pv_loadtime'
                },
                //click
                {
                    title:'元素id',
                    dataIndex:'ck_el_id'
                },
                {
                    title:'元素html',
                    dataIndex:'ck_el_html'
                },
                {
                    title:'业务埋点id',
                    dataIndex:'ck_el_trackid'
                },
                {
                    title:'元素内容',
                    dataIndex:'ck_el_content'
                },
                {
                    title:'元素类型',
                    dataIndex:'ck_el_type'
                },
                {
                    title:'a标签href',
                    dataIndex:'ck_el_href'
                },
                {
                    title:'点击位置x',
                    dataIndex:'ck_screen_x'
                },
                {
                    title:'点击位置y',
                    dataIndex:'ck_screen_y'
                },
                //request
                {
                    title:'请求地址',
                    dataIndex:'res_url'
                },
                {
                    title:'请求耗时',
                    dataIndex:'res_duration'
                },
                {
                    title:'请求追踪id',
                    dataIndex:'res_traceid'
                },
                {
                    title:'结果状态',
                    dataIndex:'res_statues'
                },
                {
                    title:'资源类型',
                    dataIndex:'res_type'
                },
                //js_err
                {
                    title:'错误类型',
                    dataIndex:'js_err_name'
                },
                {
                    title:'错误消息',
                    dataIndex:'js_err_msg'
                },
                {
                    title:'错误堆栈',
                    dataIndex:'js_err_stack'
                },
                
                //业务埋点
                {
                    title:'事件编码',
                    dataIndex:'eventcode'
                },
                {
                    title:'事件名称',
                    dataIndex:'eventname'
                },
                {
                    title:'操作类型',
                    dataIndex:'action'
                },
                {
                    title:'业务类型',
                    dataIndex:'business'
                },
                {
                    title:'业务编码',
                    dataIndex:'businesscode'
                },
                {
                    title:'商户编码',
                    dataIndex:'shopcode'
                },
                {
                    title:'商户名称',
                    dataIndex:'shopname'
                },
                {
                    title:'门店编码',
                    dataIndex:'branchcode'
                },
                {
                    title:'门店名称',
                    dataIndex:'branchname'
                },
                {
                    title:'用户编码',
                    dataIndex:'usercode'
                },
                {
                    title:'公众号ID',
                    dataIndex:'openid'
                },
                {
                    title:'unionid',
                    dataIndex:'unionid'
                },
                {
                    title:'设备编码',
                    dataIndex:'deviceid'
                },
                {
                    title:'页面进入时间',
                    dataIndex:'starttime'
                },
                {
                    title:'页面离开时间',
                    dataIndex:'endtime'
                },
                {
                    title:'行为发生的页面名称',
                    dataIndex:'pagename'
                },
                {
                    title:'自定义属性',
                    dataIndex:'attributes'
                },
                //----------------------------------
                
                {
                    title: "域名",
                    dataIndex: "url_host"
                },
                {
                    title: "url参数",
                    dataIndex: "url_path"
                },
                {
                    title: "页面标题",
                    dataIndex: "url_title"
                },
                {
                    title: "窗口宽度",
                    dataIndex: "screen_width"
                },
                {
                    title: "窗口高度",
                    dataIndex: "screen_height"
                },
                {
                    title: "前向域名",
                    dataIndex: "referrer_host"
                },
                {
                    title: "前向地址",
                    dataIndex: "referrer"
                },
                {
                    title: "IP",
                    dataIndex: "__tag__:__client_ip__"
                },
                {
                    title: "浏览器",
                    dataIndex: "browser"
                },
                {
                    title: "系统",
                    dataIndex: "os"
                },
            ],
            currentModalData:{}
        }
    },
    methods:{
        loadData(item){
            this.currentModalData = item;
            this.modalVisible = true;
        }
    }
}
</script>

<style scoped>
    .list_item_box{
        width: auto;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 10px 13px;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -moz-box-direction: normal;
        -ms-flex-flow: row nowrap;
        flex-flow: row nowrap;
    }
    .list_item_data{
        flex: 1;
        box-sizing: border-box;
        display: block;
    }
    .list_item_data_item{
        font-family: Roboto Mono,Consolas,Menlo,Courier,monospace;
        display: block;
        word-break: break-word;
        word-wrap: break-word;
        line-height: 16px;
        margin-right: 5px;
        margin-bottom: 10px;
    }
    .list_item_data_item_key{
        display: inline-flex;
        color: #333;
        font-size: 12px;
        background-color: rgba(0,86,144,.1);
        border-radius: 2px;
        padding: 1px 3px!important;
        margin: 2px 0;
    }
</style>